
<p-toast position="bottom-right">
  <ng-template let-message pTemplate="message">
    <div class="p-toast-message-text">
      <div class="p-toast-summary">{{ message.summary }}</div>
      <div class="p-toast-detail" *ngIf="message.detail">{{ message.detail }}</div>
      <button *ngIf="toastReferenceCode(message)"
              pButton pRipple type="button" icon="fa-solid fa-clipboard"
              class="p-button-text p-button-sm copy-reference-code-button"
              [cdkCopyToClipboard]="toastReferenceCode(message)"
              (cdkCopyToClipboardCopied)="copiedToClipboard()"
              pTooltip="Copy reference code">
        Copy reference code
      </button>
    </div>
  </ng-template>
</p-toast>
<p-confirmDialog></p-confirmDialog>
<div class="login-shell">
  <!-- Background layers -->
  <div class="bg">
    <div class="bg-image"></div>
    <div class="bg-gradient"></div>
    <div class="bg-noise"></div>
  </div>

  <!-- Top bar -->
  <header class="topbar">
    <div class="brand">
      <app-customer-logo></app-customer-logo>
    </div>
  </header>

  <main class="stage">
    <aside [class]="'panel panel-left '+(appConfigService.loginMotion?'anim-in2':'')">
      <app-header-logo></app-header-logo>
    </aside>

    <section class="panel panel-right">
      <div [class]="'login-card '+(appConfigService.loginMotion?'anim-in':'')">
        <!-- ⬇️ Your existing form lives entirely here -->
        <app-login-form></app-login-form>
      </div>
    </section>
  </main>
</div>


<app-dialog [(visible)]="dialogHelpVisible">
  <div app-dialog-header><i class="pi pi-comment"></i> <span translate>login.help</span></div>
  <div app-dialog-content class="help-content">
    <p translate>login.contact</p>
    <ul>
      <li><a href="" class="small-button grey help-link"><span
        class="help-link-content" translate><i class="pi pi-mobile help-icon"></i> login.telLinkFooter</span></a>
      </li>
      <li><a href="" class="small-button grey help-link-email" translate><i class="pi pi-envelope help-icon"></i>
        login.mail_address</a></li>
    </ul>

  </div>
  <div app-dialog-footer>
    <app-button (click)="dialogHelpVisible=false" [modalFooter]="true" [label]="'dialog-action.action.button.close'"
                [iconClass]="'times'"></app-button>
  </div>
</app-dialog>
